<template>
  <!-- steps -->
  <fda-steps :active="active" @click-step="stepClick">
    <fda-step>建立档案</fda-step>
    <fda-step>签约医生</fda-step>
    <fda-step>提交签约</fda-step>
    <fda-step>医生微信</fda-step>
    <fda-step>
      <slot>签约完成</slot>
      <template #node>
        <van-icon ref="node" class-prefix="fda-icon" name="checked" size="2.13333vw" />
      </template>
    </fda-step>
  </fda-steps>
</template>

<script setup lang="ts">
import { router } from '@/router';

const active = computed(() => {
  return ((router.currentRoute.value.meta?.step ?? 1) as number) - 1;
});

const stepClick = (index) => {
  console.log('cur-step:: ', index);
  // active.value = index;
};
</script>
